module.exports = __webpack_public_path__ + "static/media/sbf-launch-card-image.3acfe432.png";